import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["for"];
const _hoisted_2 = ["id", "checked", "required", "aria-required", "aria-describedby", "aria-invalid"];
const _hoisted_3 = { class: "df-checkbox__label" };
import { nextFieldId } from "../../composables/fieldId";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BaseCheckbox',
    props: {
        checked: { type: Boolean },
        required: { type: Boolean, default: false },
        ariaDescribedby: { default: undefined },
        invalid: { type: Boolean, default: false }
    },
    emits: ["update:checked"],
    setup(__props, { emit: __emit }) {
        // SYNC: see ../../_SYNC.md.
        const inputId = nextFieldId("df-check");
        const emit = __emit;
        function onChange(event) {
            emit("update:checked", event.target.checked);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("label", {
                for: _unref(inputId),
                class: "df-checkbox"
            }, [
                _createElementVNode("input", {
                    id: _unref(inputId),
                    type: "checkbox",
                    class: "df-checkbox__input",
                    checked: __props.checked,
                    required: __props.required,
                    "aria-required": __props.required,
                    "aria-describedby": __props.ariaDescribedby,
                    "aria-invalid": __props.invalid ? true : undefined,
                    onChange: onChange
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2),
                _createElementVNode("span", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "default")
                ])
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
